import { MAWB_VIEW_TABS } from '@/constants/air/master-awb';
import { MBL_VIEW_TABS } from '@/constants/master-bl';
import { PermissionsAirImportsFeatures } from '@/constants/permissions';
import { useAirMblStore } from '@/store/modules/air-imports/useAirMblStore';
import { Route } from 'vue-router';

export const getMawbViewBreadCrumbs = (route: Route) => {
  const query = route.query.tab as string;
  const airStore = useAirMblStore();
  const getLabel = (tab: string) => {
    switch (tab) {
      case MAWB_VIEW_TABS.hblList:
        return 'HBL list view';
      case MAWB_VIEW_TABS.charges:
        return 'Charges';
      case MAWB_VIEW_TABS.attachments:
        return 'Attachments';
      case MAWB_VIEW_TABS.pttApplication:
        return 'PTT Application';
      case MAWB_VIEW_TABS.milestones:
        return 'Milestones';
      case MAWB_VIEW_TABS.containers:
        return 'Containers';
      default:
        return '';
    }
  };

  const resultBreadcrumbs: any[] = [
    { text: `MAWB list view`, to: { name: 'AirImports' } },
    {
      text: `MAWB ${airStore.mbl?.shipmentNumber ?? ''}`,
      to: { name: 'MasterAWB', query: { tab: MBL_VIEW_TABS.mblDetails } },
    },
  ];
  if (query !== MBL_VIEW_TABS.mblDetails && query) {
    resultBreadcrumbs.push({ text: getLabel(query) });
  }

  return resultBreadcrumbs;
};

export const mawbRoutes = [
  {
    name: 'MasterAWBCreate',
    path: 'master-awb/create',
    meta: {
      disableWarehouseSwitch: true,
      pageTitle: 'New MAWB',

      permission: PermissionsAirImportsFeatures.MAWB,
    },
    component: () => import('@/views/air-imports/master-awb/MasterAWBCreateView.vue'),
  },
  {
    name: 'MasterAWB',
    meta: {
      disableWarehouseSwitch: true,
      pageTitle: 'MAWB',
      dynamicTitle: true,
      permission: PermissionsAirImportsFeatures.MAWB,
      breadCrumbs: getMawbViewBreadCrumbs,
    },
    path: 'master-awb/view/:id',
    props: (route: Route) => ({ id: route.params.id }),
    component: () => import('@/views/air-imports/master-awb/MasterAWBView.vue'),
  },
];
